import { Component } from '@angular/core';

@Component({
  selector: 'app-estensioni',
  templateUrl: './estensioni.component.html',
  styleUrls: ['./estensioni.component.scss']
})

export class EstensioniComponent {

  constructor() { }

  loading: boolean = false;
  headingText: string = 'Estensioni';
}
